import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ReportsIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 73.477 89.332' className={className}>
    <path
      id='Path_13054'
      data-name='Path 13054'
      d='M19.863,19.336H54c7.277,0,10.688-3.691,10.688-11.039v-6.5h6.855q10.916,0,10.9-11.039V-58.957C82.441-66.3,78.785-70,71.543-70H37.617c-7.242,0-10.9,3.691-10.9,11.039v6.5H19.863c-7.242,0-10.9,3.691-10.9,11.039V8.3C8.965,15.68,12.586,19.336,19.863,19.336ZM46.02-57.586a2.041,2.041,0,0,1-2.25-2.074V-60.4a2.024,2.024,0,0,1,2.25-2.074H63.141a2.024,2.024,0,0,1,2.25,2.074v.738a2.041,2.041,0,0,1-2.25,2.074ZM20.109,13.676c-3.621,0-5.484-1.969-5.484-5.484V-41.344c0-3.445,1.863-5.449,5.52-5.449H32.379V-26.4c0,4.43,2.25,6.609,6.609,6.609H59.027V8.191c0,3.516-1.863,5.484-5.52,5.484ZM39.656-25.1c-1.406,0-1.969-.562-1.969-1.934V-45.7l20.25,20.6Z'
      transform='translate(-8.965 69.996)'
      fill='#0087ff'
    />
  </SvgIcon>
);

export default ReportsIcon;
